import { VBtn, VProgressLinear, VIcon, VAutocomplete } from 'vuetify/lib'
import VModal from '@/vuetify_custom/v-modal_v1'
import Autocompletes from '@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js'
import VForm from '@/vuetify_custom/v-form'
import {mapGetters} from "vuex";
import styles from './index.module.less'
import { getConfigApi, submitConfigApi } from './editorServicer'
import {CONTRACT_MANAGER_CONFIG} from './constants'

const Contain = {
    props: {
        value: {
            type: Object,
        },
        index: {
            type: Number,
        },
        list: {
            type: Array
        }
    },
    data() {
        return {
            params: this.value,
        }
    },
    watch: {
        params(val) {
            this.$emit('input', val)
        },
        value(val) {
            this.params = val
        }
    },
    computed: {
        ...mapGetters('async', ['companies', 'root_teams']),
        person_in() {
            const arr = this.list.filter(i => i.id).map(i => i.id)
            return arr
        },
        person() {
            return {
                label: '审核人',
                key:'id',
                initList: this.list.filter(i => !!i.id && !!i.customer_name).map(i => ({
                    id:i.id,
                    account:i.customer_name
                })),
                type:'autocompletes_async_v1',
                'item-value':'id',
                'item-text':'account',
                api: this.$util.api.customer_select_search,
                init_list: [], // this.apply_user_list,
                cols: 2,
             //   required: true,
                out_params: {
                    formal: true,
                },
                rules: [v => !!v || '必选'],
                handle_data:({customers}) => {
                 return customers.filter(i => !this.person_in.includes(i.id))
                },
                change:(data, target = {}) => {
                    this.params.customer_name = target.account
                }
            }
        }
    },
    render() {
        return <div class={styles['contain']}>
            <div>
                {this.list.length === this.index + 1 && <VBtn color="primary" small style="margin-right: 10px" on={{
                    click:() => {
                        this.$emit('add')
                    }
                }}>添加</VBtn>}
                {this.list.length > 1 && <VBtn color="error" small on={{
                    click:() => {
                        this.$vModal.confirm({
                            title:'提示',
                            content:`确定删除第${this.index + 1}条`,
                            onOk:() => {
                                this.$emit('del', this.index)
                            }
                        })
                       
                    }
                }}>删除</VBtn>}
            </div>
            <div>
                <div>
                    <Autocompletes 
                        field={this.person}
                         v-model={this.params}
                    />
                </div>
                <VAutocomplete 
                        label="项目组"
                        item-value="id"
                        item-text="name"
                        items={[
                            {
                                id: 'all',
                                name:'全部'
                            },
                            ...this.root_teams
                        ]}
                        multiple
                        v-model={this.params.team}
                        on={{
                            change: (a) => {
                                a = a || []
                               if (a[a.length - 1] === 'all') {
                                setTimeout(() => {
                                    this.params.team = ['all']
                                   }, 100)
                                   return 
                               }
                               const index = a.indexOf('all')
                               if (index !== -1) {
                                this.params.team.splice(index, 1)
                               }
                            }
                        }}
                        rules= {[val => {
                            if (val && val.length) {
                                return true
                            }
                            return '必选'
                        }]}
                />
            </div>
            
        </div>
    }
}

const initData = () => ({
    name: null,
    key_name: CONTRACT_MANAGER_CONFIG,
    id: null,
    content: [
        {
            id: null,
            team:[]
        }
    ]
})
export default {
    data() {
        return {
            show: false,
            saving: false,
            params: initData(),
            subMitDataLoading: false,
            get_data_loading: false
        }
    },
    computed: {
        ...mapGetters('async', [ 'team_company_mapping_hash']),
        fields() {
            return [
                {
                    label:'配置名称',
                    key: 'name',
                  //  required: true,
                    rules:[v => !!v || '必填']
                },
                {
                    key: 'hint'
                }
        ]
        }
    },
    created() {
        // 建立引用关系，从后端拉数据
        this.root_teams
    },
    methods: {
        edit() {
            this.show = true
            this.get_data_loading = true
            getConfigApi.call(this, { key_name: CONTRACT_MANAGER_CONFIG }, () => {
            
                //     this.getLoading = false
               }).then(res => {
                  if (res) {
                    this.params = initData()
                    this.params.id = res.id
                    this.params.name = res.name
                    this.params.content = res.content || this.params.content
                    this.params.content.forEach(item => {
                        if (!item.team || !item.team.length) {
                            item.team = ['all']
                        }
                    })
                  } else {
                    this.params = initData()
                  }
               }).finally(() => {
                this.get_data_loading = false
               })
        },
        submit() {
            if (this.$refs.base && this.$refs.base.validate && this.$refs.base.validate()) {
                this.subMitDataLoading = true
                const params = JSON.parse(JSON.stringify(this.params))
                params.content.forEach(i => {
                    if (i.team[0] === 'all') {
                        delete i.team
                        return 
                    }
                     i.team = i.team.filter(ii => !!ii)
                });

                submitConfigApi.call(this, params).then(() => {
                  this.show = false
                   
                  }).finally(() => {
                    this.subMitDataLoading = false
                  })
            }
        
        }
    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.9}
            v-model={_this.show}
            title="编辑履约审核人员配置"
            loading={_this.subMitDataLoading}
            width={600}
            on={{
                ok: () => {
                    this.submit() 
                },
                cancel:() => {
                    this.show = false
                    // _this.params = createContractParams()
                }
            }}
        >
            {_this.get_data_loading && <VProgressLinear
                indeterminate
                color="primary"
                />}
            <VForm ref="base"
                value={this.params}
                fields={_this.fields}
                scopedSlots={{
                    hint:() => {
                        return <div >
                            <p>人员配置：</p>
                            {this.params.content.map((i, index) => {
                                
                                return <Contain list={this.params.content} index={index} v-model={i} on={{
                                    add:() => {
                                        this.params.content.push({
                                            id: null,
                                            team: []
                                        })
                                    },
                                    del: (index) => {
                                        this.params.content.splice(index, 1)
                                    }
                                }}/>
                            })}
                        </div>
                    },
  
                }}
                />
        </VModal>
    }
}